var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-inbox" } },
    [
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _c(
            "v-card-actions",
            { staticStyle: { height: "70px!important" } },
            [
              _c(
                "v-tabs",
                {
                  staticClass: "no-transition",
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    "v-tab",
                    { key: "tab-test-u" },
                    [
                      _vm._v("Game Save Actions "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { size: "20" },
                        },
                        [_vm._v("mdi-content-save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "ma-0 pa-0 mx-2",
              staticStyle: { "border-bottom": "green solid 0px" },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "ma-0 pa-0 scroll",
                  attrs: {
                    width: "100%",
                    elevation: "0",
                    height: _vm.winsize.height - 145,
                  },
                },
                [
                  _c(
                    "v-tabs-items",
                    {
                      staticClass: "mt-0",
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        "v-tab-item",
                        {
                          key: "tab-test-u",
                          attrs: {
                            transition: "fade-transition",
                            "reverse-transition": "fade-transition",
                          },
                        },
                        [_c("utils-map-save-actions-page")],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }